var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzulBrazilianAirlinesLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-18 -8.00025 156 48.0015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.307 10.72h-6.78V21.8c0 3.667-2.233 4.624-3.71 4.624-2.152 0-3.35-.957-3.35-3.708V10.72h-6.78v12.434c0 5.42 1.716 8.847 7.66 8.847 2.39 0 5.024-1.313 6.3-3.424h.08v2.83h6.58z",
    fill: "#8cd0e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 31.402h6.78V2.95H71.9V31.4zm-42.59 0h19.7v-5.18H37.926l10.33-10.362v-5.14h-18.11v5.18h9.49L29.313 26.143v5.26zm-29.31 0h7.617l1.794-5.1h9.933l1.754 5.1h7.737l-10.65-28.45H10.65L0 31.4zM14.356 10.84h.08l3.15 9.963h-6.46z",
    fill: "#002e5f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.095 2.96h1.854v1.46h-1.856z",
    fill: "#5061aa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.26 18.606h5.675v6.05h-5.675z",
    fill: "#8b328a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.992 25.95h3.73v2.26h-3.73z",
    fill: "#5d80c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.78 27.006h4.483v4.438h-4.482z",
    fill: "#e94e29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 22.977h3.838v1.68h-3.836z",
    fill: "#d5262a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 19.918h3.935v.995h-3.935z",
    fill: "#f6a022"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.166 22.977h2.75v.757h-2.75z",
    fill: "#6a95cd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 15.1h3.76v4.82h-3.76z",
    fill: "#306fb6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.586 11.404h7.35v7.203h-7.35z",
    fill: "#73c8dd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.31 11.406h4.908v3.984H95.31z",
    fill: "#92c143"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.678 4.66h8.316v6.797h-8.316z",
    fill: "#5061aa"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.683 12.286h6.06v7.397h-6.06z",
    fill: "#169bd6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.73 16.496h5.187v6.5h-5.188z",
    fill: "#f6a022"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 20.898h3.838v3.753h-3.838z",
    fill: "#d5262a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.687 23.255h4.952v2.72h-4.954z",
    fill: "#199aa6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.91 19.024h1.06v3.257h-1.06z",
    fill: "#a5bfdf"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.74 12.057h2.773v1.714h-2.772z",
    fill: "#3fb7af"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.483 13.77h2v1.115h-2z",
    fill: "#ae2258"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 8.515h3.76v6.594h-3.76z",
    fill: "#79c199"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.683 5.86h5.058v6.425h-5.056z",
    fill: "#e5df1f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.988 4.66h3.687v6.024h-3.687z",
    fill: "#33bacf"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.97 10.517H120v1.77h-5.03z",
    fill: "#6ca9db"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.746 6.637h2.402v3.882h-2.402z",
    fill: "#de5097"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.427 7.858h2.228v1.628h-2.228z",
    fill: "#604596"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M116.855 9.487H120v1.627h-3.145z",
    fill: "#fad803"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.08 2.89h1.89v1.53h-1.89zm-6.402.047h3.43V6.74h-3.43z",
    fill: "#5061aa"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.083 2.937h10.61v8.52h-10.61z",
    fill: "#0bb8e7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.525 0h3.692v4.805h-3.692z",
    fill: "#41ad4c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.85 10.73h6.85v2.67h-6.85z",
    fill: "#e7b720"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M105.1.436h2.66V4.66h-2.66z",
    fill: "#b9cf37"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M108.652 16.496h1.077v1.074h-1.08z",
    fill: "#92c143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzulBrazilianAirlinesLogowine);
export default __webpack_public_path__ + "static/media/Azul_Brazilian_Airlines-Logo.wine.2c9ee8d7205e21f64ac6da84b3b7eb0e.svg";
export { ForwardRef as ReactComponent };